import { render, staticRenderFns } from "./channelShare.vue?vue&type=template&id=d712a886"
import script from "./channelShare.vue?vue&type=script&lang=js"
export * from "./channelShare.vue?vue&type=script&lang=js"
import style0 from "./channelShare.vue?vue&type=style&index=0&id=d712a886&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports